import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'
import router from './router'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import 'bootstrap/dist/js/bootstrap.bundle'
import "bootstrap/dist/js/bootstrap.min.js";
import "./assets/scss/app.scss"
import 'vue3-openlayers/dist/vue3-openlayers.css'
import '@vuepic/vue-datepicker/dist/main.css'
import "vue-multiselect/dist/vue-multiselect.css"
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css'
import 'vue-rate/dist/vue-rate.css'
import 'vue3-tour/dist/vue3-tour.css'
import "v3-tour/dist/vue-tour.css";
import 'vue3-simple-typeahead/dist/vue3-simple-typeahead.css';
import '@globalhive/vuejs-tour/dist/style.css';





import VueFeather from "vue-feather";
import Breadcrumbs from './layout/breadCrumbs.vue';
import VueApexCharts from "vue3-apexcharts";
import vueChartist from "vue-chartist"
import OpenLayersMap from 'vue3-openlayers'
import VueNumber from "vue-number-animation";
import VCalendar from 'v-calendar';
import Lightbox from 'vue-easy-lightbox'
import VueSweetalert2 from 'vue-sweetalert2';
import Toaster from "@meforma/vue-toaster";
import Datepicker from '@vuepic/vue-datepicker';
import Multiselect from 'vue-multiselect'
import AosVue from "aos-vue";
import { VueMasonryPlugin } from 'vue-masonry';
import PerfectScrollbar from 'vue3-perfect-scrollbar'
import Notifications from '@kyvg/vue3-notification'
import rate from 'vue-rate'
import Vue3Tour from 'vue3-tour'
import VueTour from 'v3-tour'
import { quillEditor } from "vue3-quill";
import SimpleTypeahead from 'vue3-simple-typeahead';
import KnobControl from 'vue-knob-control'
import VueJsTour from '@globalhive/vuejs-tour';


import English from "./locales/en.json"
import German from "./locales/ge.json"
import Russian from "./locales/ru.json"
import Arabic from "./locales/ar.json"
import Español from "./locales/es.json"
import Deutsch from "./locales/de.json"
import Français from "./locales/fr.json"
import Português from "./locales/pt.json"
import 简体中文 from "./locales/cn.json"
import لعربية from "./locales/ae.json"

import { createI18n } from 'vue-i18n'
const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: 'English',
    fallbackLocale: 'English',
    messages: {
        English: English,
        German: German,
        Russian: Russian,
        Arabic: Arabic,
        Español: Español,
        Deutsch: Deutsch,
        Français: Français,
        Português: Português,
        简体中文: 简体中文,
        لعربية: لعربية,
    }
})

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App)
app.use(pinia)
app.use(router)
app.use(VueApexCharts)
app.use(OpenLayersMap)
app.use(vueChartist)
app.use(VueNumber)
app.use(Lightbox)
app.use(Toaster)
app.use(AosVue)
app.use(rate)
app.use(i18n)
app.use(Vue3Tour)
app.use(VueTour)
app.use(VueJsTour)
app.use(quillEditor)
app.use(Notifications)
app.use(KnobControl)
app.use(VueMasonryPlugin)
app.use(PerfectScrollbar)
app.use(SimpleTypeahead)
app.use(VCalendar, {})
app.provide('Swal', VueSweetalert2)
app.component(VueFeather.name ?? '', VueFeather)
app.component('Breadcrumbs', Breadcrumbs)
app.component('Datepicker', Datepicker)
app.component('multiselect', Multiselect)
app.mount('#app')
